import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient, NotFoundError } from '../shared/api/client';

import {
    Appointment,
    AvailabilityConfig,
    AvailabilityConfigPayload,
    CalendarProvider,
    CalendarStatus,
    ConnectCalendarPayload,
} from './types';

const AGENCY_NETWORK_MANAGEMENT_API_URL = getEnvRequired('AGENCY_NETWORK_MANAGEMENT_API_URL');

const apiClient = new ApiClient();

export async function getCalendarStatus(): Promise<CalendarStatus> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/calendar-provider/status`;
    try {
        return await apiClient.get<CalendarStatus>(url);
    } catch (error) {
        // 404 means no calendar has ever been connected — treat as empty status
        if (error instanceof NotFoundError) return {};
        throw error;
    }
}

export async function connectCalendar(payload: ConnectCalendarPayload): Promise<void> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/calendar-provider`;
    const body = JSON.stringify(payload);
    const headers = { 'Content-Type': 'application/json' };
    await apiClient.post<unknown>(url, body, headers);
}

export async function disconnectCalendar(provider: CalendarProvider): Promise<void> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/calendar-provider?provider=${provider}`;
    await apiClient.delete<unknown>(url);
}

export async function getAvailabilityConfig(): Promise<AvailabilityConfig> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/configuration`;
    return apiClient.get<AvailabilityConfig>(url);
}

export async function putAvailabilityConfig(
    payload: AvailabilityConfigPayload,
): Promise<AvailabilityConfig> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/configuration`;
    return apiClient.put<AvailabilityConfig>(url, JSON.stringify(payload), {
        'Content-Type': 'application/json',
    });
}

export async function fetchDossierAppointments(resourceId: string): Promise<Appointment[]> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/appointments?resourceId=${resourceId}`;
    return apiClient.get<Appointment[]>(url);
}
